import avivaRing from '../images/aviva-ring.png';
import avivaBannerGraph from '../images/aviva-banner-graph.png';
import avivaScreens from '../images/aviva-cc-screens.jpg';
import avivaWhyChooseIcons from '../images/aviva-icons-whychoose.png';

/** Partial override merged onto defaultLanding when REACT_APP_PARTNER=aviva. */
export default {
  images: {
    ring: avivaRing,
    steps: avivaBannerGraph,
    screens: avivaScreens,
    whyChooseIcons: avivaWhyChooseIcons,
  },
  copy: {
    heroHeading: {
      kicker: 'keep you awake at night?',
    },
    bcmHeading: {
      kicker: 'What is business',
      title: 'continuity management',
    },
    bcmLead:
      'Business continuity enables you to identify potential threats and their impacts to your business operations.',
    whyRequirement:
      'Business Continuity Institute Good Practice Guidelines & International Organization for Standardization (ISO 22301 Societal Security — Business Continuity Management Systems) requirements',
    whyRequirementAfter: '',
    whyItems: [
      {
        title: 'Visualise',
        body: 'Identifying and visualising the many aspects of risk that may affect your business',
      },
      {
        title: 'Understand',
        body: 'Delivering a broad understanding of your organisational threats and its business imperatives',
      },
      { title: 'Improve', body: 'Identifying opportunities to improve operational processes' },
      { title: 'Plan', body: 'Providing plans to recover your crisis areas' },
      { title: 'Test', body: 'Scenarios and testing levels for self-evaluation' },
    ],
    recoverLead:
      "LMI ContinuityCoach is modelled on International Organization for Standardization ISO 22301 standards and the Business Continuity Institute ('BCI') Good Practice Guidelines (GPG: 2013/2018). It is designed to be an easy-to-use, cost effective and highly available web-based continuity tool.",
    benefits: [
      'help improve the chance of survival',
      'make your business more attractive to insurers',
      'reduce downtime',
      'opportunistically improve efficiency and costs',
      'provide a competitive advantage',
    ],
    ctaHeading: {
      title: 'Fast. Secure. Easy',
    },
    newsTitle: 'Latest news',
    newsCta: 'More news',
  },
  disruptionColors: {
    blue: '#1c4fd2',
    darkBlue: '#191d64',
    yellow: '#ffd900',
    red: '#f59b1b',
    green: '#37afba',
  },
  surfaces: {
    accent: '#ffd900',
    bcmText: '#191d64',
  },
  benefitBox: {
    background: '#191d64',
    text: '#ffffff',
    accent: '#37afba',
  },
  flags: {
    sentenceCase: true,
    citeRequirement: true,
    unifiedBenefitAccent: true,
  },
};
